import { Link, useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Check } from "lucide-react";
import Seo from "@/components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CONFIRMATION_SEO = (
  <Seo title="Reservation Received" description="Your reservation request at Hotel Azulo Inn has been received." noindex />
);

export default function Confirmation() {
  const { id } = useParams();
  const location = useLocation();
  const [booking, setBooking] = useState(location.state?.booking || null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (booking) return;
    axios
      .get(`${API}/bookings/${id}`)
      .then((r) => setBooking(r.data))
      .catch(() => setError(true));
  }, [id, booking]);

  if (error) return (
    <div className="pt-40 pb-24 text-center">
      <h1 className="font-serif text-4xl text-ink-900">Reservation not found</h1>
      <Link to="/book" className="mt-6 inline-block text-sage-dark">Start again →</Link>
    </div>
  );
  if (!booking) return <div className="pt-40 pb-24 text-center text-ink-500">Loading…</div>;

  return (
    <div className="pt-32 md:pt-40 pb-32" data-testid="booking-confirmation">
      {CONFIRMATION_SEO}
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <div className="w-14 h-14 mx-auto border-2 border-sage rounded-full flex items-center justify-center bg-sage/10">
          <Check className="w-6 h-6 text-sage-dark" />
        </div>
        <div className="mt-8 overline">Reservation request received</div>
        <h1 className="mt-6 font-serif text-4xl md:text-6xl leading-[1.02] text-ink-900">
          Thank you, <span className="italic text-sage-dark">{booking.full_name.split(" ")[0]}.</span>
        </h1>
        <p className="mt-8 max-w-lg mx-auto text-ink-700 leading-relaxed">
          A member of our reservations team will confirm availability and rates within the day,
          and reach out to <span className="text-ink-900 font-medium">{booking.email}</span>.
        </p>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 border-y hairline py-10 text-left">
          <div>
            <div className="overline">Room</div>
            <div className="mt-2 font-serif text-xl text-ink-900">{booking.room_name}</div>
          </div>
          <div>
            <div className="overline">Check in</div>
            <div className="mt-2 font-serif text-xl text-ink-900">{booking.check_in}</div>
          </div>
          <div>
            <div className="overline">Check out</div>
            <div className="mt-2 font-serif text-xl text-ink-900">{booking.check_out}</div>
          </div>
          <div>
            <div className="overline">Nights</div>
            <div className="mt-2 font-serif text-xl text-sage-dark">{booking.nights}</div>
          </div>
        </div>

        <div className="mt-12 text-xs text-ink-500">
          Reference: <span className="text-ink-800">{booking.id}</span>
        </div>

        <Link
          to="/"
          data-testid="confirmation-home-btn"
          className="mt-12 inline-flex items-center h-12 px-8 border border-ink-900/20 text-ink-900 text-[12px] tracking-[0.22em] uppercase hover:border-sage hover:text-sage-dark transition-colors"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
